<template>
  <MultiSelect class="language-switcher"
               :options="languages"
               v-model="selectedLang"
               :allow-empty="false"
               :close-on-select="true"
               :deselectLabel="$t('multiselect.deselectLabel')"
               :placeholder="$t('multiselect.placeholder')"
               :searchable="false"
               :selectLabel="$t('multiselect.selectLabel')"
               :selectedLabel="$t('multiselect.selectedLabel')"
               :show-labels="false"
               @input="changeLang"
  ></MultiSelect>
</template>

<script>
import MultiSelect from 'vue-multiselect';

export default {
  name: 'LanguageSwitcher',
  components: {
    MultiSelect,
  },
  data() {
    return {
      languages: [],
      selectedLang: 'pl-PL',
    };
  },
  mounted() {
    const langs = this.$i18n.messages;
    this.languages = Object.keys(langs);
    this.selectedLang = this.$i18n.locale;
  },
  methods: {
    changeLang() {
      this.$i18n.locale = this.selectedLang;
      localStorage.setItem('language', this.selectedLang);
    },
  },
};
</script>

<style scoped lang="scss">
  .language-switcher {
    width: 90px;
  }
</style>
